/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		4: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"route-play","1":"route-rules","2":"route-home","3":"route-about"}[chunkId]||chunkId) + ".chunk." + {"0":"be460","1":"50061","2":"db44b","3":"d69ce"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exec", function() { return exec; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.props;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.props.default ? 0 : rank(vnode.props.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href')) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		var children = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["toChildArray"])(this.props.children);
		return this.getMatchingChildren(children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this.setState({ url: url });

		var didRoute = this.canRoute(url);

		// trigger a manual re-route if we're not in the middle of an update:
		if (!this.updating) {
			this.forceUpdate();
		}

		return didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.props.path, vnode.props);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["toChildArray"])(children), url, true);

		var current = active[0] || null;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["createElement"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["createElement"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/unistore/preact.js
var preact = __webpack_require__("o6ac");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// EXTERNAL MODULE: ./store/index.js + 1 modules
var store = __webpack_require__("vdRI");

// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/home/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function (require) {
				cb( __webpack_require__("iOg+") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var home = (async_default()(load));
	
// CONCATENATED MODULE: ./routes/play/index.js

		

		function play_load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("lS8S") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var play = (async_default()(play_load));
	
// CONCATENATED MODULE: ./routes/rules/index.js

		

		function rules_load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function (require) {
				cb( __webpack_require__("8z9l") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var rules = (async_default()(rules_load));
	
// CONCATENATED MODULE: ./routes/about/index.js

		

		function about_load(cb) {
			__webpack_require__.e/* require.ensure */(3).then((function (require) {
				cb( __webpack_require__("LOGg") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var about = (async_default()(about_load));
	
// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./components/header/style.css
var style = __webpack_require__("u3et");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./components/header/index.js






var _ref = Object(preact_min["h"])("img", {
  src: "/assets/icons/white/streamline-icon-board-game-dice-1@24x24.png",
  alt: "Add a player"
});

var _ref2 = Object(preact_min["h"])("div", null);

var header_Header = function Header() {
  return Object(preact_min["h"])(
    "header",
    { "class": style_default.a.header },
    Object(preact_min["h"])(
      "h1",
      null,
      Object(preact_min["h"])(
        match["Link"],
        { activeClassName: style_default.a.active, href: "/" },
        _ref,
        "farkle.fun"
      )
    ),
    Object(preact_min["h"])(
      "nav",
      null,
      Object(preact_min["h"])(
        "div",
        { "class": style_default.a.Icon },
        _ref2
      ),
      Object(preact_min["h"])(
        "div",
        { "class": style_default.a.Links },
        Object(preact_min["h"])(
          match["Link"],
          { activeClassName: style_default.a.active, href: "/play" },
          "Play"
        ),
        Object(preact_min["h"])(
          match["Link"],
          { activeClassName: style_default.a.active, href: "/rules" },
          "Rules"
        ),
        Object(preact_min["h"])(
          match["Link"],
          { activeClassName: style_default.a.active, href: "/about" },
          "About"
        )
      )
    )
  );
};

/* harmony default export */ var header = (header_Header);
// EXTERNAL MODULE: ./style/index.css
var style_0 = __webpack_require__("rq4c");
var style_default_0 = /*#__PURE__*/__webpack_require__.n(style_0);

// CONCATENATED MODULE: ./index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return index_App; });


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// process.env.NODE_ENV = "development";
// require("preact/debug");







// Code-splitting is automated for routes









var index__ref = Object(preact_min["h"])(header, null);

var index__ref2 = Object(preact_min["h"])(home, { path: "/" });

var _ref3 = Object(preact_min["h"])(play, { path: "/play" });

var _ref4 = Object(preact_min["h"])(rules, { path: "/rules" });

var _ref5 = Object(preact_min["h"])(about, { path: "/about" });

var index_App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleRoute = function (evt) {
      _this.currentUrl = evt.url;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */


  App.prototype.render = function render() {
    return Object(preact_min["h"])(
      preact["Provider"],
      { store: store["b" /* default */] },
      Object(preact_min["h"])(
        "div",
        { id: style_default_0.a.app },
        index__ref,
        Object(preact_min["h"])(
          preact_router_es["Router"],
          { onChange: this.handleRoute },
          index__ref2,
          _ref3,
          _ref4,
          _ref5
        )
      )
    );
  };

  return App;
}(preact_min["Component"]);



/***/ }),

/***/ "KM04":
/***/ (function(module, exports) {

var n,
    l,
    u,
    t,
    i,
    o,
    r,
    f = {},
    e = [],
    c = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord/i;function s(n, l) {
  for (var u in l) {
    n[u] = l[u];
  }return n;
}function a(n) {
  var l = n.parentNode;l && l.removeChild(n);
}function p(n, l, u) {
  var t,
      i = arguments,
      o = {};for (t in l) {
    "key" !== t && "ref" !== t && (o[t] = l[t]);
  }if (arguments.length > 3) for (u = [u], t = 3; t < arguments.length; t++) {
    u.push(i[t]);
  }if (null != u && (o.children = u), "function" == typeof n && null != n.defaultProps) for (t in n.defaultProps) {
    void 0 === o[t] && (o[t] = n.defaultProps[t]);
  }return h(n, o, l && l.key, l && l.ref);
}function h(l, u, t, i) {
  var o = { type: l, props: u, key: t, ref: i, __k: null, __: null, __b: 0, __e: null, __d: null, __c: null, constructor: void 0 };return n.vnode && n.vnode(o), o;
}function v(n) {
  return n.children;
}function y(n, l) {
  this.props = n, this.context = l;
}function d(n, l) {
  if (null == l) return n.__ ? d(n.__, n.__.__k.indexOf(n) + 1) : null;for (var u; l < n.__k.length; l++) {
    if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
  }return "function" == typeof n.type ? d(n) : null;
}function m(n) {
  var l, u;if (null != (n = n.__) && null != n.__c) {
    for (n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++) {
      if (null != (u = n.__k[l]) && null != u.__e) {
        n.__e = n.__c.base = u.__e;break;
      }
    }return m(n);
  }
}function x(l) {
  (!l.__d && (l.__d = !0) && 1 === u.push(l) || i !== n.debounceRendering) && ((i = n.debounceRendering) || t)(w);
}function w() {
  var n, l, t, i, o, r, f;for (u.sort(function (n, l) {
    return l.__v.__b - n.__v.__b;
  }); n = u.pop();) {
    n.__d && (t = void 0, i = void 0, r = (o = (l = n).__v).__e, (f = l.__P) && (t = [], i = N(f, o, s({}, o), l.__n, void 0 !== f.ownerSVGElement, null, t, null == r ? d(o) : r), T(t, o), i != r && m(o)));
  }
}function g(n, l, u, t, i, o, r, c, s) {
  var p,
      h,
      v,
      y,
      m,
      x,
      w,
      g = u && u.__k || e,
      _ = g.length;if (c == f && (c = null != o ? o[0] : _ ? d(u, 0) : null), p = 0, l.__k = k(l.__k, function (u) {
    if (null != u) {
      if (u.__ = l, u.__b = l.__b + 1, null === (v = g[p]) || v && u.key == v.key && u.type === v.type) g[p] = void 0;else for (h = 0; h < _; h++) {
        if ((v = g[h]) && u.key == v.key && u.type === v.type) {
          g[h] = void 0;break;
        }v = null;
      }if (y = N(n, u, v = v || f, t, i, o, r, c, s), (h = u.ref) && v.ref != h && (w || (w = []), v.ref && w.push(v.ref, null, u), w.push(h, u.__c || y, u)), null != y) {
        if (null == x && (x = y), null != u.__d) y = u.__d, u.__d = null;else if (o == v || y != c || null == y.parentNode) {
          n: if (null == c || c.parentNode !== n) n.appendChild(y);else {
            for (m = c, h = 0; (m = m.nextSibling) && h < _; h += 2) {
              if (m == y) break n;
            }n.insertBefore(y, c);
          }"option" == l.type && (n.value = "");
        }c = y.nextSibling, "function" == typeof l.type && (l.__d = y);
      }
    }return p++, u;
  }), l.__e = x, null != o && "function" != typeof l.type) for (p = o.length; p--;) {
    null != o[p] && a(o[p]);
  }for (p = _; p--;) {
    null != g[p] && z(g[p], g[p]);
  }if (w) for (p = 0; p < w.length; p++) {
    j(w[p], w[++p], w[++p]);
  }
}function k(n, l, u) {
  if (null == u && (u = []), null == n || "boolean" == typeof n) l && u.push(l(null));else if (Array.isArray(n)) for (var t = 0; t < n.length; t++) {
    k(n[t], l, u);
  } else u.push(l ? l("string" == typeof n || "number" == typeof n ? h(null, n, null, null) : null != n.__e || null != n.__c ? h(n.type, n.props, n.key, null) : n) : n);return u;
}function _(n, l, u, t, i) {
  var o;for (o in u) {
    o in l || C(n, o, null, u[o], t);
  }for (o in l) {
    i && "function" != typeof l[o] || "value" === o || "checked" === o || u[o] === l[o] || C(n, o, l[o], u[o], t);
  }
}function b(n, l, u) {
  "-" === l[0] ? n.setProperty(l, u) : n[l] = "number" == typeof u && !1 === c.test(l) ? u + "px" : null == u ? "" : u;
}function C(n, l, u, t, i) {
  var o, r, f, e, c;if (i ? "className" === l && (l = "class") : "class" === l && (l = "className"), "key" === l || "children" === l) ;else if ("style" === l) {
    if (o = n.style, "string" == typeof u) o.cssText = u;else {
      if ("string" == typeof t && (o.cssText = "", t = null), t) for (r in t) {
        u && r in u || b(o, r, "");
      }if (u) for (f in u) {
        t && u[f] === t[f] || b(o, f, u[f]);
      }
    }
  } else "o" === l[0] && "n" === l[1] ? (e = l !== (l = l.replace(/Capture$/, "")), c = l.toLowerCase(), l = (c in n ? c : l).slice(2), u ? (t || n.addEventListener(l, P, e), (n.l || (n.l = {}))[l] = u) : n.removeEventListener(l, P, e)) : "list" !== l && "tagName" !== l && "form" !== l && "type" !== l && !i && l in n ? n[l] = null == u ? "" : u : "function" != typeof u && "dangerouslySetInnerHTML" !== l && (l !== (l = l.replace(/^xlink:?/, "")) ? null == u || !1 === u ? n.removeAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase()) : n.setAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase(), u) : null == u || !1 === u ? n.removeAttribute(l) : n.setAttribute(l, u));
}function P(l) {
  this.l[l.type](n.event ? n.event(l) : l);
}function N(l, u, t, i, o, r, f, e, c) {
  var a,
      p,
      h,
      d,
      m,
      x,
      w,
      _,
      b,
      C,
      P = u.type;if (void 0 !== u.constructor) return null;(a = n.__b) && a(u);try {
    n: if ("function" == typeof P) {
      if (_ = u.props, b = (a = P.contextType) && i[a.__c], C = a ? b ? b.props.value : a.__ : i, t.__c ? w = (p = u.__c = t.__c).__ = p.__E : ("prototype" in P && P.prototype.render ? u.__c = p = new P(_, C) : (u.__c = p = new y(_, C), p.constructor = P, p.render = A), b && b.sub(p), p.props = _, p.state || (p.state = {}), p.context = C, p.__n = i, h = p.__d = !0, p.__h = []), null == p.__s && (p.__s = p.state), null != P.getDerivedStateFromProps && (p.__s == p.state && (p.__s = s({}, p.__s)), s(p.__s, P.getDerivedStateFromProps(_, p.__s))), d = p.props, m = p.state, h) null == P.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);else {
        if (null == P.getDerivedStateFromProps && _ !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(_, C), !p.__e && null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(_, p.__s, C)) {
          for (p.props = _, p.state = p.__s, p.__d = !1, p.__v = u, u.__e = t.__e, u.__k = t.__k, p.__h.length && f.push(p), a = 0; a < u.__k.length; a++) {
            u.__k[a] && (u.__k[a].__ = u);
          }break n;
        }null != p.componentWillUpdate && p.componentWillUpdate(_, p.__s, C), null != p.componentDidUpdate && p.__h.push(function () {
          p.componentDidUpdate(d, m, x);
        });
      }p.context = C, p.props = _, p.state = p.__s, (a = n.__r) && a(u), p.__d = !1, p.__v = u, p.__P = l, a = p.render(p.props, p.state, p.context), u.__k = k(null != a && a.type == v && null == a.key ? a.props.children : a), null != p.getChildContext && (i = s(s({}, i), p.getChildContext())), h || null == p.getSnapshotBeforeUpdate || (x = p.getSnapshotBeforeUpdate(d, m)), g(l, u, t, i, o, r, f, e, c), p.base = u.__e, p.__h.length && f.push(p), w && (p.__E = p.__ = null), p.__e = null;
    } else u.__e = $(t.__e, u, t, i, o, r, f, c);(a = n.diffed) && a(u);
  } catch (l) {
    n.__e(l, u, t);
  }return u.__e;
}function T(l, u) {
  n.__c && n.__c(u, l), l.some(function (u) {
    try {
      l = u.__h, u.__h = [], l.some(function (n) {
        n.call(u);
      });
    } catch (l) {
      n.__e(l, u.__v);
    }
  });
}function $(n, l, u, t, i, o, r, c) {
  var s,
      a,
      p,
      h,
      v,
      y = u.props,
      d = l.props;if (i = "svg" === l.type || i, null == n && null != o) for (s = 0; s < o.length; s++) {
    if (null != (a = o[s]) && (null === l.type ? 3 === a.nodeType : a.localName === l.type)) {
      n = a, o[s] = null;break;
    }
  }if (null == n) {
    if (null === l.type) return document.createTextNode(d);n = i ? document.createElementNS("http://www.w3.org/2000/svg", l.type) : document.createElement(l.type), o = null;
  }if (null === l.type) null != o && (o[o.indexOf(n)] = null), y !== d && (n.data = d);else if (l !== u) {
    if (null != o && (o = e.slice.call(n.childNodes)), p = (y = u.props || f).dangerouslySetInnerHTML, h = d.dangerouslySetInnerHTML, !c) {
      if (y === f) for (y = {}, v = 0; v < n.attributes.length; v++) {
        y[n.attributes[v].name] = n.attributes[v].value;
      }(h || p) && (h && p && h.__html == p.__html || (n.innerHTML = h && h.__html || ""));
    }_(n, d, y, i, c), l.__k = l.props.children, h || g(n, l, u, t, "foreignObject" !== l.type && i, o, r, f, c), c || ("value" in d && void 0 !== d.value && d.value !== n.value && (n.value = null == d.value ? "" : d.value), "checked" in d && void 0 !== d.checked && d.checked !== n.checked && (n.checked = d.checked));
  }return n;
}function j(l, u, t) {
  try {
    "function" == typeof l ? l(u) : l.current = u;
  } catch (l) {
    n.__e(l, t);
  }
}function z(l, u, t) {
  var i, o, r;if (n.unmount && n.unmount(l), (i = l.ref) && j(i, null, u), t || "function" == typeof l.type || (t = null != (o = l.__e)), l.__e = l.__d = null, null != (i = l.__c)) {
    if (i.componentWillUnmount) try {
      i.componentWillUnmount();
    } catch (l) {
      n.__e(l, u);
    }i.base = i.__P = null;
  }if (i = l.__k) for (r = 0; r < i.length; r++) {
    i[r] && z(i[r], u, t);
  }null != o && a(o);
}function A(n, l, u) {
  return this.constructor(n, u);
}function D(l, u, t) {
  var i, r, c;n.__ && n.__(l, u), r = (i = t === o) ? null : t && t.__k || u.__k, l = p(v, null, [l]), c = [], N(u, (i ? u : t || u).__k = l, r || f, f, void 0 !== u.ownerSVGElement, t && !i ? [t] : r ? null : e.slice.call(u.childNodes), c, t || f, i), T(c, l);
}n = { __e: function __e(n, l) {
    for (var u; l = l.__;) {
      if ((u = l.__c) && !u.__) try {
        if (u.constructor && null != u.constructor.getDerivedStateFromError) u.setState(u.constructor.getDerivedStateFromError(n));else {
          if (null == u.componentDidCatch) continue;u.componentDidCatch(n);
        }return x(u.__E = u);
      } catch (l) {
        n = l;
      }
    }throw n;
  } }, l = function l(n) {
  return null != n && void 0 === n.constructor;
}, y.prototype.setState = function (n, l) {
  var u;u = this.__s !== this.state ? this.__s : this.__s = s({}, this.state), "function" == typeof n && (n = n(u, this.props)), n && s(u, n), null != n && this.__v && (this.__e = !1, l && this.__h.push(l), x(this));
}, y.prototype.forceUpdate = function (n) {
  this.__v && (this.__e = !0, n && this.__h.push(n), x(this));
}, y.prototype.render = v, u = [], t = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, o = f, r = 0, exports.render = D, exports.hydrate = function (n, l) {
  D(n, l, o);
}, exports.createElement = p, exports.h = p, exports.Fragment = v, exports.createRef = function () {
  return {};
}, exports.isValidElement = l, exports.Component = y, exports.cloneElement = function (n, l) {
  return l = s(s({}, n.props), l), arguments.length > 2 && (l.children = e.slice.call(arguments, 2)), h(n.type, l, l.key || n.key, l.ref || n.ref);
}, exports.createContext = function (n) {
  var l = {},
      u = { __c: "__cC" + r++, __: n, Consumer: function Consumer(n, l) {
      return n.children(l);
    }, Provider: function Provider(n) {
      var t,
          i = this;return this.getChildContext || (t = [], this.getChildContext = function () {
        return l[u.__c] = i, l;
      }, this.shouldComponentUpdate = function (l) {
        n.value !== l.value && t.some(function (n) {
          n.context = l.value, x(n);
        });
      }, this.sub = function (n) {
        t.push(n);var l = n.componentWillUnmount;n.componentWillUnmount = function () {
          t.splice(t.indexOf(n), 1), l && l.call(n);
        };
      }), n.children;
    } };return u.Consumer.contextType = u, u;
}, exports.toChildArray = k, exports._e = z, exports.options = n;
//# sourceMappingURL=preact.js.map

/***/ }),

/***/ "o6ac":
/***/ (function(module, exports, __webpack_require__) {

var t = __webpack_require__("KM04");function n(t, n) {
  for (var r in n) {
    t[r] = n[r];
  }return t;
}function r(t) {
  this.getChildContext = function () {
    return { store: t.store };
  };
}r.prototype.render = function (t) {
  return t.children && t.children[0] || t.children;
}, exports.connect = function (r, e) {
  var o;return "function" != typeof r && ("string" == typeof (o = r || {}) && (o = o.split(/\s*,\s*/)), r = function r(t) {
    for (var n = {}, r = 0; r < o.length; r++) {
      n[o[r]] = t[o[r]];
    }return n;
  }), function (o) {
    function i(i, u) {
      var c = this,
          f = u.store,
          s = r(f ? f.getState() : {}, i),
          a = e ? function (t, n) {
        "function" == typeof t && (t = t(n));var r = {};for (var e in t) {
          r[e] = n.action(t[e]);
        }return r;
      }(e, f) : { store: f },
          p = function p() {
        var t = r(f ? f.getState() : {}, i);for (var n in t) {
          if (t[n] !== s[n]) return s = t, c.setState({});
        }for (var e in s) {
          if (!(e in t)) return s = t, c.setState({});
        }
      };this.componentWillReceiveProps = function (t) {
        i = t, p();
      }, this.componentDidMount = function () {
        f.subscribe(p);
      }, this.componentWillUnmount = function () {
        f.unsubscribe(p);
      }, this.render = function (r) {
        return t.h(o, n(n(n({}, a), r), s));
      };
    }return (i.prototype = new t.Component()).constructor = i;
  };
}, exports.Provider = r;
//# sourceMappingURL=preact.js.map

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "rq4c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children({
			url: url,
			path: path,
			matches: (0, _preactRouter.exec)(path, props.path, {}) !== false
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "u3et":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"header__3QGkI","active":"active__3gItZ","Links":"Links__1ncx1","Icon":"Icon__wSI15"};

/***/ }),

/***/ "vdRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/unistore/dist/unistore.es.js
function n(n, t) {
  for (var r in t) {
    n[r] = t[r];
  }return n;
}/* harmony default export */ var unistore_es = (function (t) {
  var r = [];function u(n) {
    for (var t = [], u = 0; u < r.length; u++) {
      r[u] === n ? n = null : t.push(r[u]);
    }r = t;
  }function e(u, e, f) {
    t = e ? u : n(n({}, t), u);for (var i = r, o = 0; o < i.length; o++) {
      i[o](t, f);
    }
  }return t = t || {}, { action: function action(n) {
      function r(t) {
        e(t, !1, n);
      }return function () {
        for (var u = arguments, e = [t], f = 0; f < arguments.length; f++) {
          e.push(u[f]);
        }var i = n.apply(this, e);if (null != i) return i.then ? i.then(r) : r(i);
      };
    }, setState: e, subscribe: function subscribe(n) {
      return r.push(n), function () {
        u(n);
      };
    }, unsubscribe: u, getState: function getState() {
      return t;
    } };
});
//# sourceMappingURL=unistore.es.js.map
// CONCATENATED MODULE: ./store/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* unused harmony export tally */
/* unused harmony export sum */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// TODO make env var?
var DICE_COUNT = 6;
var DICE_SIDES = 6;
var DICE_INITIAL_VALUE = 0;
var MAX_SCORE = 10000;
var BASELINE_SCORE = 500;

/* harmony default export */ var store = __webpack_exports__["b"] = (unistore_es({
  cup: startingDice(),
  combos: [],
  players: [
    // {
    //   name: "Stuart",
    //   score: 0,
    //   turns: [], // TODO at end of every turn push rolls here
    //   farkles: 0
    // }
  ],
  current_player: 0, // index in players array
  current_turn_score: 0,
  max_score: MAX_SCORE,
  match_started: false
}));

var actions = function actions(store) {
  return {
    startMatch: function startMatch() {
      store.setState({
        match_started: true
      });
    },
    endMatch: function endMatch() {
      store.setState({
        match_started: false
      });
    },
    addSlot: function addSlot(state) {
      store.setState({
        players: [].concat(state.players, [{
          name: null,
          score: 0,
          turns: [],
          farkles: 0
        }])
      });
    },
    addPlayer: function addPlayer(state, evt) {
      var players = [].concat(state.players);
      players[evt.target.dataset.index] = {
        name: evt.target.value,
        score: 0,
        turns: [],
        farkles: 0
      };

      store.setState({
        players: players
      });
    },
    removePlayer: function removePlayer(state, index) {
      var players = [].concat(state.players);
      players.splice(index, 1);
      store.setState({
        players: players
      });
    },
    lock: function lock(state, die) {
      // console.log("lock die position", die);

      // Can't lock dice until they've been rolled
      if (state.combos.length) {
        var cup = [].concat(state.cup);
        var selectedDie = cup.find(function (el) {
          return el.die === die;
        });

        var combos = [].concat(state.combos);
        var currentCombo = [].concat(combos[combos.length - 1]);

        if (selectedDie.locked) {
          selectedDie.locked = false;
          currentCombo = currentCombo.filter(function (el) {
            return el.die !== die;
          });
        } else {
          selectedDie.locked = true;
          var containsDie = currentCombo.find(function (el) {
            return el.die === die;
          });
          if (!containsDie) {
            currentCombo.push(selectedDie);
          }
        }

        combos[combos.length - 1] = currentCombo;

        store.setState({ cup: cup, combos: combos });
      }
    },


    roll: function roll(state) {
      console.log("roll", state);

      var cup = shake(state.cup);
      var combos = [].concat(state.combos, [[]]);
      var currentPlayer = state.players[state.current_player];

      var potentialRollScore = sum(cup.filter(function (die) {
        return !die.locked;
      }).map(function (die) {
        return die.value;
      }));

      // console.log("potentialRollScore", potentialRollScore);

      // if every die is locked and all combos score then the dice are hot
      var hotDice = false;
      var unLocked = cup.filter(function (die) {
        return !die.locked;
      });
      if (unLocked.length === 0) {
        // confirm all combos score
        for (var index = 0; index < state.combos.length; index++) {
          var combo = state.combos[index];
          var score = sum(combo);

          console.log("LOOP", score, combo);
          // If any combo doesn't score then the dice are not hot
          if (!score) {
            hotDice = false;
            break;
          } else {
            hotDice = true;
          }
        }
      }

      if (hotDice) {
        console.log("Dice are hot!");

        // Reset game board and keep same current player
        store.setState({
          cup: shake(startingDice()),
          combos: combos
        });
      } else if (potentialRollScore) {
        // Allow player to select score
        store.setState({
          combos: combos,
          cup: cup
        });
      } else {
        // Player roll has no score potential so turn is over.

        // Player can only farkle when on the board
        if (currentPlayer.score >= BASELINE_SCORE) {
          alert("Farkle");
          currentPlayer.farkles = currentPlayer.farkles + 1;
        }

        // Capture players turn
        // currentPlayer.turns = [
        //   ...currentPlayer.turns,
        //   {
        //     combos: state.combos,
        //     score: score
        //   }
        // ];

        // determine next player
        var nextPlayer = state.current_player + 1 > state.players.length - 1 ? 0 // go back to player one
        : state.current_player + 1;

        // Reset game board
        store.setState({
          cup: startingDice(),
          combos: [],
          current_player: nextPlayer
        });
      }
    },

    endTurn: function endTurn(state) {
      console.log("endTurn", state);

      // determine next player
      var nextPlayer = state.current_player + 1 > state.players.length - 1 ? 0 // go back to player one
      : state.current_player + 1;

      var currentPlayer = state.players[state.current_player];

      // Tally score
      var score = tally(state.combos);

      // save players rolls
      // let players = [...state.players];

      // In order to put points on the board you have land
      // a role of the BASELINE_SCORE or greater. Once scored all points
      // go on the board
      if (currentPlayer.score || score >= BASELINE_SCORE) {
        currentPlayer.score = currentPlayer.score + score;
      }

      if (score) {
        currentPlayer.farkles = 0;
      }

      // Capture players turn
      currentPlayer.turns = [].concat(currentPlayer.turns, [{
        combos: state.combos,
        score: score
      }]);

      store.setState({
        cup: startingDice(),
        combos: [],
        current_player: nextPlayer
        // players
      });
    }
  };
};

function startingDice(amount, sides, initialValue) {
  return new Array(DICE_COUNT).fill().map(function (_, i) {
    return {
      die: i,
      sides: DICE_SIDES,
      value: DICE_INITIAL_VALUE,
      locked: false
    };
  });
}

function shake(dice) {
  return dice.map(function (die) {
    if (!die.locked) {
      return _extends({}, die, {
        value: Math.floor(Math.random() * die.sides) + 1
      });
    } else {
      return die;
    }
  });
}

// Adds up combos into numerical score
function tally(combos) {
  return combos.reduce(function (acc, combo) {
    var selected = combo.filter(function (die) {
      return die.locked;
    });
    var values = selected.map(function (die) {
      return die.value;
    });

    acc = acc + sum(values);
    return acc;
  }, 0);
}

// Determines a set of dices score
// Rules engine
function sum(values) {
  console.log("sum", values);

  var score = 0;

  // Order dice by numerical value
  var numericallySorted = values.sort(function (a, b) {
    return a - b;
  });

  // Find all value matches
  var matches = numericallySorted.reduce(function (acc, value) {
    if (acc[value]) {
      acc[value].count = acc[value].count + 1;
    } else {
      acc[value] = {
        count: 1
      };
    }
    return acc;
  }, {});

  var matchedDice = Object.keys(matches);

  // Edge Case: flush
  if (numericallySorted.join("-") === "1-2-3-4-5-6") {
    console.log("flush: 1-2-3-4-5-6");
    score = 3000;
    return score;
  }

  // Edge Case: double triple
  // 2 sets of 3 of a kind
  // If we were given a full set of dice and there are only 2 match groups
  if (numericallySorted.length === 6 && matchedDice.length === 2) {
    // and each group contains a count of 3 then we have 2 sets of 3 of a kind
    var pair = matchedDice.filter(function (value) {
      return matches[value].count === 3;
    });
    if (pair.length === 2) {
      console.log("2 sets of 3 of a kind");
      score = 2500;
      return score;
    }
  }

  // Edge Case: triple pair
  // 3 sets of 2 of a kind
  if (numericallySorted.length === 6 && matchedDice.length === 3) {
    var triple = matchedDice.filter(function (value) {
      return matches[value].count === 2;
    });
    if (triple.length === 3) {
      console.log("triple pair");
      score = 1500;
      return score;
    }
  }

  // All other cases
  score = matchedDice.reduce(function (acc, value, index) {
    var count = matches[value].count;

    switch (String(count)) {
      case "6":
        // BUG currently selecting 6 die regardless of their kind triggers a 6 of a kind match
        // TODO confirm the 6 are of the same kind
        console.log("six of a kind", count, matches);
        acc += 3000;
        break;

      case "5":
        console.log("five of a kind");
        acc += 2000;
        break;

      case "4":
        console.log("four of a kind");
        acc += 1000;
        break;

      // In the case of a triple pair. e.g. 5-5-5-5-4-4
      // Which has a higher score is captured by the edge case
      // checks before this main switch statement

      case "3":
        console.log("three of a kind");
        switch (value) {
          case "6":
            acc += 600;
            break;
          case "5":
            acc += 500;
            break;
          case "4":
            acc += 400;
            break;
          case "3":
            acc += 300;
            break;
          case "2":
            acc += 200;
            break;
          case "1":
            acc += 1000;
            break;
        }
        break;

      case "2":
        // NOTE: triple pairs are handled by the "tiple pair" edge case

        // handle 1-1 & 5-5 cases where there isn't a triple pair
        // but these would score as 200 & 100 respectively

        if (value == 5) {
          console.log("5 pair");

          acc += 100;
        }
        if (value == 1) {
          console.log("1 pairs");

          acc += 200;
        }
        break;

      case "1":
        if (value == 5) {
          console.log("one 5 die value");

          acc += 50;
        }
        if (value == 1) {
          console.log("one 1 die value");

          acc += 100;
        }
        break;

      default:
        // no score
        // 0 points
        break;
    }

    // console.table({
    //   index,
    //   value,
    //   count,
    //   score: acc
    // });

    // Building up score
    return acc;
  }, 0);

  console.log("SCORE: ", score);

  return score;
}

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.2b9cf.js